import { getCKEditorInstance } from '@/annotation/ckEditor.utilities';
import { COMMAND_NAME, CopyForEmail } from '@/annotation/ckEditorPlugins/plugins/CopyForEmail';

/** Runs the same copy-for-email flow as the report CKEditor toolbar (CopyForEmail plugin). */
export function runReportCopyForEmail(): void {
  const editor = getCKEditorInstance('reportEditor');
  if (!editor) {
    return;
  }
  const plugin = editor.plugins.get(CopyForEmail.pluginName) as CopyForEmail | undefined;
  if (!plugin) {
    return;
  }
  plugin.shouldCopyForEmail = true;
  editor.execute(COMMAND_NAME);
}
